/**
 * @param {string} userSlug
 * @param {string} gameSlug
 */
export const shortUrl = (userSlug, gameSlug) => `https://app.pitch2table.com/d/${userSlug}/${gameSlug}`;

/**
 * @param {string} userSlug
 * @param {string} gameSlug
 */
export const shortUrlFeedback = (userSlug, gameSlug) => {
  return `https://app.pitch2table.com/d/${userSlug}/${gameSlug}/feedback`;
};

/**
 * @param {string} userSlug
 * @param {string} gameSlug
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestId} playTestId
 */
export const shortUrlPlayTestFeedback = (userSlug, gameSlug, playTestId) => {
  return `https://app.pitch2table.com/d/${userSlug}/${gameSlug}/feedback/${playTestId}`;
};

/**
 * @param {string} userSlug
 * @param {string} gameSlug
 * @param {string} pnpSlug
 */
export const shortUrlPnp = (userSlug, gameSlug, pnpSlug) => {
  return `https://app.pitch2table.com/d/${userSlug}/${gameSlug}/pnp/${pnpSlug}`;
};

/**
 * @param {string} userSlug
 */
export const shortProfileUrl = (userSlug) => `https://app.pitch2table.com/d/${userSlug}`;
